// WorkspaceSwitcher — shows the current workspace name and lets the user switch.
// Progressive disclosure: hidden when the user has only one workspace.
//
// v3.14 rules: flat access, el.call for registered functions, design tokens only.

export const WorkspaceSwitcherItem = {
  extends: 'Button',
  flow: 'x',
  align: 'center left',
  gap: 'Z1',
  padding: 'Z1 A',
  round: 'Z',
  cursor: 'pointer',
  theme: 'tertiary',
  width: '100%',

  Icon: { name: 'layers', boxSize: 'A A' },
  Name: {
    tag: 'span',
    fontSize: 'Z2',
    text: (el, s) => s.name || s.title || ''
  },

  onClick: (e, el, s) => {
    e.preventDefault()
    let dropdown = el.parent
    while (dropdown && !dropdown.WorkspaceSwitcherDropdown) dropdown = dropdown.parent
    if (dropdown?.WorkspaceSwitcherDropdown) {
      dropdown.WorkspaceSwitcherDropdown.update?.({
        style: { opacity: '0', visibility: 'hidden', pointerEvents: 'none' }
      })
    }
    el.call('switchWorkspace', s.root, el.context?.sdk, el.context?.queryClient, s.id)
    localStorage.setItem('activeWorkspace', s.id)
  }
}

export const WorkspaceSwitcherDropdown = {
  position: 'absolute',
  top: '100%',
  left: '0',
  zIndex: '100',
  minWidth: 'G',
  padding: 'Z',
  round: 'A',
  theme: 'dialog',
  boxShadow: '0 A Z -Z black.2',
  opacity: '0',
  visibility: 'hidden',
  pointerEvents: 'none',

  childExtends: 'WorkspaceSwitcherItem',
  childrenAs: 'state',
  children: (el, s) => s.root?.workspaces || []
}

export const WorkspaceSwitcher = {
  position: 'relative',
  // Progressive disclosure — hide when only one workspace
  hide: (el, s) => !s.root?.workspaces || s.root.workspaces.length <= 1,

  Trigger: {
    extends: 'Button',
    flow: 'x',
    align: 'center left',
    gap: 'Z1',
    padding: 'Z1 A',
    round: 'Z',
    cursor: 'pointer',
    theme: 'tertiary',

    Icon: { name: 'layers', boxSize: 'A A' },
    Name: {
      tag: 'span',
      fontSize: 'Z2',
      text: (el, s) => s.root?.workspace?.name || 'Select workspace'
    },
    ChevronIcon: { name: 'chevronDown', boxSize: 'A A' },

    onClick: (e, el) => {
      e.stopPropagation()
      const switcher = el.parent
      const dropdown = switcher?.WorkspaceSwitcherDropdown
      if (!dropdown) return
      const next = !dropdown.forcedVisible
      dropdown.forcedVisible = next
      dropdown.update?.({
        style: {
          opacity: next ? '1' : '0',
          visibility: next ? 'visible' : 'hidden',
          pointerEvents: next ? 'auto' : 'none'
        }
      })
    }
  },

  WorkspaceSwitcherDropdown: {}
}
